import _ from "lodash";

/**
 * merge rule, where new array override old
 */
export function arrayOverrideMergeRule(objValue, srcValue, key, object, source) {
  if (_.isArray(srcValue)) {
    return srcValue
  }

  return undefined
}



// WEBPACK FOOTER //
// ./src/helpers/merge.js